import React from 'react';
import { useState } from 'react';
import { IoIosArrowDropdown } from 'react-icons/io';
import { Link } from 'react-router-dom';

const CibilInsightMobile = ({title}) => {
    const [isExpanded, setExpanded] = useState(false);
    const toggleExpand = () => {
        setExpanded(!isExpanded);
    };
    return (
    <Link to='/profile/creditCards' className='flex flex-col justify-center rounded-lg bg-white shadow-sm w-full h-full p-2'>
        
        <div className='flex flex-col justify-around items-start'>
            <div className='flex flex-col gap-1 w-full'>
                <p className='text-primary text-sm'>{title}</p>
                <div className='flex flex-row justify-between w-full'>
                    <div className='flex flex-col justify-around items-start gap-1'>
                        <p className='text-[9px] text-black font-semibold'>11 Accounts</p>
                        <div className='flex flex-row justify-around items-center gap-1'>
                            <p className='text-[8px] text-green-500 font-semibold'>10 Active</p>
                            <p className='text-[8px] text-red-500 font-semibold'>00 Closed</p>    
                        </div>
                    </div>
                    <div className='flex flex-col justify-center items-center h-full'><p className='text-xs text-black font-semibold'>₹ 41,83,126</p></div>
                </div>
            </div>
            
        </div>
        {/* {!isExpanded ? 
            <div className='flex flex-row justify-end items-center w-full'>
                <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 text-primary text-[8px]">View More <IoIosArrowDropdown className='ml-1'/></button>
            </div> :
            <div className='flex flex-row justify-end items-center w-full'>
                <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 text-primary text-[8px]">View Less <IoIosArrowDropup className='ml-1'/></button>
            </div>
        } */}
        <div  className='flex flex-row justify-end items-center w-full'>
            <button onClick = {()=> toggleExpand()} className="flex flex-row justify-around items-center hover:text-blue-500 text-primary text-[9px]">View More <IoIosArrowDropdown className='ml-1'/></button>
        </div>
    </Link>
    )
}

export default CibilInsightMobile;